import service from "../../request/request"
export function pclogin(auto, pass,code) {
    return service({
        url: "/api/login/login",
        method: 'POST',
        data: {
            row: {
                account:auto,
                password:pass,
                val_code:code,
            }
        }
    })
}
export function get_verification_info() {
    return service({
        url: "/api/login/get_verification",
        method: 'POST',
    })
}
export function get_customer_list() {
    return service({
        url: "/pc/monitoring/home/home/get_customer_list",
        method: 'POST',
    })
}


export function get_info() {
    return service({
        url: "/pc/monitoring/user_info/get_info",
        method: 'POST',
      
    })
}